// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background-color: #fff;
}
:host body {
  background-color: #fff;
}
:host .iframe-wrapper {
  -webkit-overflow-scrolling: touch !important;
  overflow-y: scroll !important;
  width: 100%;
  height: 600px;
}
:host iframe {
  width: 100%;
  border: none;
  overflow: scroll;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
